import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { MoneyBackGuaranteePageView } from '../../app.constants';
import { NgIf } from '@angular/common';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { RegimenService } from '@services/regimen-service';
import { EventLoggerService } from '@services/event-logger-service';
import {
  MoneyBackGuaranteeBottomsheetComponent
} from '@shared/bottom-sheet-layouts/money-back-guarentee-bottomsheet/money-back-guarantee-bottomsheet.component';
import { AppConfig } from '../../app.config';

const mbgClickEventRegimen2200 = 'MBG_strip_regimen_2200';
const mbgClickEventRegimen3000 = 'MBG_strip_regimen_3000';
const mbgClickEventHomepage = 'MBG_upgrade_plan_homepage';

@Component({
  selector: 'app-money-back-guarantee-banner',
  imports: [
    NgIf
  ],
  templateUrl: './money-back-guarantee-banner.component.html',
})

export class MoneyBackGuaranteeBannerComponent {
  @Input() pageView: MoneyBackGuaranteePageView = MoneyBackGuaranteePageView.HOME;
  @Input() regimen: any;

  public readonly MoneyBackGuaranteePageView = MoneyBackGuaranteePageView;

  constructor(
    private readonly bottomSheet: MatBottomSheet,
    private readonly router: Router,
    private readonly regimenService: RegimenService,
    private readonly eventLogger: EventLoggerService,
    private readonly appConfig: AppConfig
  ) {}

  onHomeBannerClick(): void {
    if (!this.regimen?.class) {
      return;
    }

    this.fireMBGClickEvent(mbgClickEventHomepage);
    const regimenClass = this.regimen.class;
    this.router.navigate(['/user'], {
      queryParams: {
        tab: this.appConfig.Shared.TABS.REGIMEN,
        class: regimenClass,
        variant: this.appConfig.Shared.Regimen.VariantId.variant_1999
      }
    });
  }

  onRegimenBannerClick(): void {
    const selectedVariant = this.regimenService.getSelectedVariantIdFromRegimen(this.regimen);
    if (!selectedVariant) return

    const eventName = this.getEventNameForVariant(selectedVariant);
    this.fireMBGClickEvent(eventName);

    this.bottomSheet.open(MoneyBackGuaranteeBottomsheetComponent, {
      data: {}
    });
  }

  private getEventNameForVariant(variantId: string): string {
    const variantEventMap: Record<string, string> = {
      'variant_1999': mbgClickEventRegimen2200,
      'variant_4999': mbgClickEventRegimen3000,
    };

    return variantEventMap[variantId];
  }

  fireMBGClickEvent(eventName: string): void {
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: eventName }));
  }
}
